import { ChefHat } from "lucide-react";
import { useEffect, useRef, useState } from "react";

import PedidoCard from "./PedidoCard";
import { Skeleton } from "@/components/ui/skeleton";
import { chaveDaComanda } from "../lib/envios";
import { alturaEstimada } from "../lib/kds";

// Espelho do .kds-grid (minmax 300px, gap 12px) e do p-3 do container.
const MIN_COL = 300;
const GAP = 12;
const PAD = 12;
const CHROME = 130; // cabecalho + rodape do card

/** Cartões de pedido em cinza enquanto a 1ª leitura chega (dono, 25/10/2026):
 *  cabeçalho (código e tempo), linhas de item e o botão da base. Também na
 *  tela do Garçom. O polling de 3 s não volta a eles. */
export function CartoesKdsCarregando({ desktop, quantos = 3 }) {
  return (
    <div className={desktop ? "kds-grid" : "flex flex-col gap-3"} data-e2e="kds-carregando" aria-busy="true" aria-label="Carregando">
      {Array.from({ length: quantos }, (_, i) => (
        <div key={i} className="rounded-xl border bg-card p-3 flex flex-col gap-3">
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-6 w-14 rounded-full" />
          </div>
          <Skeleton className="h-4 w-32" />
          {Array.from({ length: 3 - (i % 2) }, (_, j) => (
            <div key={j} className="flex items-center gap-2">
              <Skeleton className="h-8 w-8 rounded-md shrink-0" />
              <Skeleton className="h-4 flex-1" />
            </div>
          ))}
          <Skeleton className="h-10 w-full rounded-lg" />
        </div>
      ))}
    </div>
  );
}

/** Uma coluna do KDS (Em Producao ou Prontos). No desktop ela se mede e
 *  decide quantas colunas de grade tem e quanta altura util sobra — e' isso
 *  que faz um pedido grande virar card duplo/triplo em vez de ficar cortado
 *  ou obrigar a rolar. */
export default function ColunaKds({ col, lista, desktop, products, indexOf, selecao, onAcao, limiares, up, itens, folga, carregando = false }) {
  const ref = useRef(null);
  const [medida, setMedida] = useState({ colunas: 1, alturaUtil: 600 });

  useEffect(() => {
    const el = ref.current;
    if (!desktop || !el) return undefined;
    const medir = () => setMedida({
      colunas: Math.max(1, Math.floor((el.clientWidth - PAD * 2 + GAP) / (MIN_COL + GAP))),
      alturaUtil: Math.max(320, el.clientHeight - PAD * 2 - CHROME),
    });
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, [desktop]);

  const spanDe = (p) => (desktop
    ? Math.min(3, medida.colunas, Math.max(1, Math.ceil(alturaEstimada(p) / medida.alturaUtil)))
    : 1);

  return (
    <section className="flex-1 min-w-0 flex flex-col min-h-0">
      {desktop && (
        <div className={`${col.headerBg} text-white px-4 py-2 rounded-t-xl flex items-center justify-between flex-shrink-0`}>
          <span className="font-bold text-sm">{col.label}</span>
          {!carregando && <span className="bg-white/20 text-xs font-bold px-2.5 py-0.5 rounded-full">{lista.length}</span>}
        </div>
      )}
      <div ref={ref} className={`${col.bg} border ${desktop ? "rounded-b-xl border-t-0" : "rounded-xl"} flex-1 min-h-0 overflow-y-auto p-2 sm:p-3 ${folga ? "!pb-24" : ""}`}>
        {carregando ? <CartoesKdsCarregando desktop={desktop} /> : lista.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-muted-foreground gap-2">
            <ChefHat className="w-8 h-8 opacity-30" />
            <span className="text-sm">Nenhum pedido {col.status === "producao" ? "em produção" : "pronto"}</span>
          </div>
        ) : (
          <div className={desktop ? "kds-grid" : "flex flex-col gap-3"}>
            {lista.map((p) => {
              const idx = indexOf(p);
              const escolhido = desktop && idx === selecao.card;
              return (
                <PedidoCard key={p._cardId} pedido={p} column={col} onAcao={onAcao}
                  products={products} up={{ ativo: up.ativo, status: up.status[p.id] }}
                  kdsIndex={idx} isSelected={escolhido} mobile={!desktop} span={spanDe(p)} limiares={limiares}
                  selecionados={p._parcial ? [] : itens.selecionadosDe(chaveDaComanda(p))}
                  onAlternarItem={itens.alternar} onDesfazerItem={itens.desfazer} onLimparSelecao={itens.limpar} />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
